<template>
    <div class="line">
        <div class="line">
            <span class="tit">
                <span class="txt-blue">{{ title }}</span>
                <div class="com-tooltip">
                    <button class="icon"></button>
                    <div class="detail">
                        <span class="tit">{{ title }}</span>
                        <p v-if="type === 'p' || type === 'd' || type === 'o'" class="txt">
                            ·고정금액 : 1회 당 설정한 고정금액으로 정산합니다.
                            <br />
                            ·고정퍼센트 : 1회 당 단가에서 설정한 퍼센트로 정산합니다.
                            <br />
                            ·횟수별 금액 : 설정한 구간에 속한 총 횟수만큼 설정한 금액으로 정산합니다.
                            <br />
                            ·횟수별 퍼센트 : 설정한 구간에 속한 총 횟수만큼 설정한 퍼센트로 정산합니다.
                        </p>
                        <p v-else-if="type === 'g'" class="txt">
                            ·타임별 : 1회 당 고정 금액으로 정산합니다.
                            <br />
                            ·인당 : 1명 당 고정 금액으로 정산합니다.
                            <br />
                            ·인원별 : 참여 회원수별로 차등을 주어 수업을 많이 진행할수록 수업료를 높게 받을 수 있습니다.
                            기본 수업료는 어느정도 보장하면서, 많은 인원이 참여할 수록 수업료를 높게 받을 수 있게
                            합니다.
                            <br />
                        </p>
                    </div>
                </div>
            </span>
            <div class="input-cnt">
                <div v-for="(item, index) in codes[`less_${type}_type_cd`]" :key="index" class="com-radio">
                    <input
                        :id="`radio-${type}-type-${index}`"
                        v-model="data[`lesson${keyword}Type`]"
                        :value="item.value"
                        type="radio"
                        @change="isShow"
                    />
                    <label :for="`radio-${type}-type-${index}`">{{ item.text }}</label>
                </div>
            </div>
            <div class="input-cnt box-type">
                <!-- 고정 -->
                <div v-if="(data[`lesson${keyword}Type`] || '').search(/^(F|MO|TM)/) >= 0" class="section">
                    <input v-model="data[`lesson${keyword}Price`]" class="w220" type="text" />
                    <span class="txt">{{ (data[`lesson${keyword}Type`] || '').charAt(1) == 'P' ? '%' : '원' }}</span>
                </div>
                <!-- 횟수 별 -->
                <div v-if="(data[`lesson${keyword}Type`] || '').search(/^(C|MT)/) >= 0" class="section">
                    <salary-range
                        v-model="data[`lesson${keyword}Ranges`]"
                        :centerId="$parent.cId"
                        :centerStaffId="$parent.centerStaffId"
                        :settingHistorySeq="data.settingHistorySeq"
                        :type="data[`lesson${keyword}Type`]"
                    />
                </div>
            </div>
        </div>
        <div v-if="data[`lesson${keyword}Type`] === 'FP' || data[`lesson${keyword}Type`] === 'CP'" class="line">
            <span class="tit">
                부가세 정책
                <div class="com-tooltip">
                    <button class="icon"></button>
                    <div class="detail">
                        <span class="tit">부가세 정책</span>
                        <p class="txt">
                            고정 퍼센트 또는 횟수별 퍼센트를 선택 한 경우, 부가세 제외 후 정산 할 것인지 부가세를
                            제외하지 않고 정산 할 것인지 설정 가능합니다.
                            <br />
                            <br />

                            (예시)
                            <br />
                            결제금액 : 10회 550,000원, 급여설정 : 50% 인 경우
                            <br />
                            <br />

                            &lt;부가세 포함 계산법&gt;
                            <br />
                            1회당 단가 : 550,000원 / 10회 = 55,000원
                            <br />
                            정산금액 : 55,000원 X 0.5 = 27,500원
                            <br />
                            <br />

                            &lt;부가세 제외 후 계산법&gt;
                            <br />
                            부가세 제외 이용권 금액 : 550,000원 / 1.1 = 500,000원
                            <br />
                            1회당 단가 : 500,000원 / 10회 = 50,000원
                            <br />
                            정산금액 : 50,000원 X 0.5 = 25,000원
                        </p>
                    </div>
                </div>
            </span>
            <salary-vat
                :id="`lesson-${type}-vat`"
                :value="data[`lesson${keyword}PriceVatYn`]"
                @input="changeSalaryVatYn"
            />
        </div>
        <div class="line">
            <span class="tit">
                NO-SHOW(결석) 정책
                <span v-if="!checkNoShow2(type, keyword, data)" class="red">*전체인원 결석 시 적용</span>
            </span>

            <div class="input-cnt flex-col">
                <div v-for="(item, index) in codes[`less_${type}_atnd_type_cd`]" :key="index" class="sub-line">
                    <div v-if="item.value == 'CME'" class="com-radio">
                        <input
                            :id="`lesson-${type}-atnd-${item.value}`"
                            v-model="data[`lesson${keyword}AtndType`]"
                            :name="`lesson-${type}-atnd`"
                            :value="item.value"
                            checked
                            type="radio"
                            @input="changeLessonAtndType"
                        />
                        <label :for="`lesson-${type}-atnd-${item.value}`">
                            횟수차감과 동시에 동일한 금액으로 정산합니다.
                        </label>
                    </div>
                    <template v-else-if="item.value == 'CMF'">
                        <div v-if="checkNoShow(type, keyword, data)" class="flex">
                            <div class="com-radio">
                                <input
                                    :id="`lesson-${type}-atnd-${item.value}`"
                                    v-model="data[`lesson${keyword}AtndType`]"
                                    :name="`lesson-${type}-atnd`"
                                    :value="item.value"
                                    type="radio"
                                    @input="changeLessonAtndType"
                                />
                                <label :for="`lesson-${type}-atnd-${item.value}`">횟수차감과 동시에</label>
                            </div>
                            <input
                                :disabled="data[`lesson${keyword}AtndType`] !== 'CMF'"
                                :value="data[`lesson${keyword}AtndTypeValuePrice`]"
                                class="w90 center"
                                type="text"
                                @input="changeLessonAtndTypeValue"
                            />
                            <span class="txt">원으로 정산합니다.</span>
                        </div>
                    </template>
                    <template v-else-if="item.value == 'CMP'">
                        <div v-if="checkNoShow(type, keyword, data)" class="flex">
                            <div class="com-radio">
                                <input
                                    :id="`lesson-${type}-atnd-${item.value}`"
                                    v-model="data[`lesson${keyword}AtndType`]"
                                    :name="`lesson-${type}-atnd`"
                                    :value="item.value"
                                    type="radio"
                                    @input="changeLessonAtndType"
                                />
                                <label :for="`lesson-${type}-atnd-${item.value}`">횟수차감과 동시에 기존급여의</label>
                            </div>
                            <input
                                :disabled="data[`lesson${keyword}AtndType`] !== 'CMP'"
                                :value="data[`lesson${keyword}AtndTypeValuePercent`]"
                                class="w60 center"
                                type="text"
                                @input="changeLessonAtndTypeValue"
                            />
                            <span class="txt">% 으로 정산합니다.</span>
                        </div>
                    </template>
                    <div v-else class="com-radio">
                        <input
                            :id="`lesson-${type}-atnd-${item.value}`"
                            v-model="data[`lesson${keyword}AtndType`]"
                            :name="`lesson-${type}-atnd`"
                            :value="item.value"
                            type="radio"
                            @input="changeLessonAtndType"
                        />
                        <label :for="`lesson-${type}-atnd-${item.value}`">
                            횟수차감만 하고 정산하지 않습니다. (정산금액 0원)
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SalaryVat from './EmployeeSalaryVat';
import SalaryRange from './EmployeeSalaryRange';

export default {
    name: 'SettingEmployeeSalaryType',
    components: { SalaryVat, SalaryRange },
    props: ['title', 'type', 'keyword', 'codes', 'data'],
    mounted() {
        console.log('this.type', this.type);
        console.log('this.data', this.data);
        console.log('this.codes', this.codes);
    },
    watch: {
        'data.applyEndDate': {
            deep: true,
            handler(v) {
                console.log(v);
            },
        },
    },
    methods: {
        checkNoShow(type, keyword, data) {
            if (
                (data[`lesson${this.keyword}Type`] === 'CA' || data[`lesson${this.keyword}Type`] === 'FA') &&
                type === 'd'
            ) {
                return false;
            }
            if (data[`lesson${this.keyword}Type`] === 'MT' && type === 'g') {
                return false;
            }
            return true;
        },
        checkNoShow2(type, keyword, data) {
            if (
                (data[`lesson${this.keyword}Type`] === 'CA' || data[`lesson${this.keyword}Type`] === 'FA') &&
                type === 'd'
            ) {
                return false;
            }
            if (data[`lesson${this.keyword}Type`] !== 'MO' && type === 'g') {
                return false;
            }
            return true;
        },
        changeSalaryVatYn(value) {
            this.data[`lesson${this.keyword}PriceVatYn`] = value;
            this.$emit('change-data', this.data);
        },
        changeLessonAtndType(e) {
            this.data[`lesson${this.keyword}AtndType`] = e.target.value;
            if (this.data[`lesson${this.keyword}AtndType`] === 'CMF') {
                this.data[`lesson${this.keyword}AtndTypeValuePercent`] = '';
            } else if (this.data[`lesson${this.keyword}AtndType`] === 'CMP') {
                this.data[`lesson${this.keyword}AtndTypeValuePrice`] = '';
            }
            this.$emit('change-data', this.data);
        },
        changeLessonAtndTypeValue(e) {
            if (this.data[`lesson${this.keyword}AtndType`] === 'CMF') {
                this.data[`lesson${this.keyword}AtndTypeValue`] = e.target.value;
                this.data[`lesson${this.keyword}AtndTypeValuePrice`] = e.target.value;
                this.data[`lesson${this.keyword}AtndTypeValuePercent`] = '';
            } else if (this.data[`lesson${this.keyword}AtndType`] === 'CMP') {
                this.data[`lesson${this.keyword}AtndTypeValue`] = e.target.value;
                this.data[`lesson${this.keyword}AtndTypeValuePrice`] = '';
                this.data[`lesson${this.keyword}AtndTypeValuePercent`] = e.target.value;
            } else {
                this.data[`lesson${this.keyword}AtndTypeValuePrice`] = '';
                this.data[`lesson${this.keyword}AtndTypeValuePercent`] = '';
                this.data[`lesson${this.keyword}AtndTypeValue`] = '';
            }
            console.log('데이터', this.data);
            this.$emit('change-data', this.data);
        },
        isShow() {
            this.$emit('is-show', this.data[`lesson${this.keyword}Type`]);
        },
    },
};
</script>
